module.exports = __webpack_public_path__ + "8ffb8e26134e6996f3be9e8537128710.svg";